import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link, Button } from 'components/ui';
import Modal from 'components/Modal/Modal';
import typography from 'style/typography';
import ComponentList from 'components/Content/ComponentList';
import getModal from 'services/api/cms/getModal';
import { globalModals as globalModalsConstants } from 'utils/globalModals';
import ContentConstants from 'constants/content';
import { globalModalsSelector } from 'selectors/page/headerFooterTemplate/data/globalModals/globalModalsSelector';
import localeUtils from 'utils/LanguageLocale';
import GuidelinesModalLinkEN from 'components/ProductPage/RatingsAndReviews/GuidelinesModalLink/locales/GuidelinesModalLink_en_US';
import GuidelinesModalLinkFR from 'components/ProductPage/RatingsAndReviews/GuidelinesModalLink/locales/GuidelinesModalLink_fr_CA';

const { CONTEXTS } = ContentConstants;
const { COMMUNITY_RATINGS_REVIEWS } = globalModalsConstants;
const getText = localeUtils.getLocalisedDataFromResource(GuidelinesModalLinkEN, GuidelinesModalLinkFR);

const GuidelinesModalLink = () => {
    const globalModals = useSelector(globalModalsSelector, shallowEqual);
    const [contentData, setContentData] = useState(null);
    const [showGuidelines, setShowGuidelines] = useState(false);

    const closeModal = () => setShowGuidelines(false);

    const openModal = () => {
        const { sid } = globalModals[COMMUNITY_RATINGS_REVIEWS] || {};

        if (contentData) {
            setShowGuidelines(true);
        } else if (sid) {
            const { country, channel, language } = Sephora.renderQueryParams;
            getModal({ country, language, channel, sid })
                .then(data => {
                    setShowGuidelines(true);
                    setContentData(data?.data);
                })
                .catch(error => {
                    Sephora.logger.error('Failed to load review guidelines modal content from Contentful', error);
                });
        } else {
            Sephora.logger.error('Review guidelines modal SID not configured in globalModals.COMMUNITY_RATINGS_REVIEWS');
        }
    };

    return (
        <>
            <Link
                onClick={openModal}
                color='blue'
                padding={2}
                margin={-2}
                underline={true}
            >
                {getText('ratingsAndReviewsGuidelines')}
            </Link>
            {showGuidelines && contentData && (
                <Modal
                    isOpen={true}
                    onDismiss={closeModal}
                    width={contentData?.width || 2}
                >
                    <Modal.Header>
                        <Modal.Title>{contentData?.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body css={typography}>
                        <ComponentList
                            items={contentData?.items}
                            context={CONTEXTS.MODAL}
                            removeFirstItemMargin={true}
                            removeLastItemMargin={true}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant='primary'
                            hasMinWidth={true}
                            children={getText('done')}
                            onClick={closeModal}
                        />
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

export default wrapFunctionalComponent(GuidelinesModalLink, 'GuidelinesModalLink');
